import { styled } from '@linaria/react';

export const SkeletonContainer = styled.div`
	width: 100%;
	height: 100%;
	animation: shimmer 2s infinite linear;
	background: linear-gradient(
		90deg,
		var(--color-white-xs) 25%,
		var(--color-white-m) 50%,
		var(--color-white-xs) 75%
	);
	background-size: 200% 100%;

	@keyframes shimmer {
		from {
			background-position: 200% 0;
		}
		to {
			background-position: -200% 0;
		}
	}
`;
